import logo from '../../assets/logo-bandi-white.svg';
import locales from '../../locales.json';

const { HEADER_TEXTS } = locales;

const Header = () => (
  <header className="appbar">
    <img className="logo" src={logo} alt={HEADER_TEXTS.logoAlt} />
  </header>
);

export default Header;
